import React, { Component } from 'react';
import { connect } from 'react-redux';
// import SwipeableViews from 'react-swipeable-views';
// import { View, ScrollView, StyleSheet } from 'react-native'
import _ from 'lodash';

import ReactIScroll from 'react-iscroll';
import iScroll from 'iscroll';
import shared from '../../../utils/shared.js'
import {getFileType, videoType} from '../../../utils/fileHelpers';

import CircleImageInfoBlock from '../../General/CircleImageInfoBlock'
import InfoBlock from '../../General/InfoBlock'

import StoryChicagoModal from './StoryChicagoModal'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

var spacialEvents;
const config = {
    events_on_screen: 4,
    line_thickness: 0.05,
}

class Timeline extends Component {

    constructor(props) {
        super(props);
        this.refDict = {};
        this.state = {
            spacialEvents: null,
            sideMargin: null,
            totalHeight: null,
            currentEvent: 0,
            showStory: false,
            story: {
                contextualheader: null, //use name of timeline
                headline: null,
                subtitle: null,
                body: null,
                quote: null,
                mainimage: null,
                story_id: null,
                slickAssets: null
            },
            initializedRefs: false,
            module: this.props.module
        }
        this._baseInset = this.props.screen.r16_9.p10 * 1.25;
        this._eventIndex = 0;
        this._titleStyle = {
            position: 'absolute',
            fontFamily: 'aleo-bolditalic', fontSize: this.props.screen.r16_9.p10,
            left: this.props.screen.r16_9.width * .05,
        }
        this._titleHorizontalRule = {
            width: '90%',
            height: this.props.screen.r16_9.p10 * 0.15,
            backgroundColor: '#223954',
            display: 'inline-block',
            position: 'absolute',
            top: this.props.screen.r16_9.p10 * 1.25,
            left: 0,
            marginLeft: this.props.screen.r16_9.width * .05,
        }
        this._bottomNavOffset = 0;
        if (this.props.content.settings.custom_vars && this.props.content.settings.custom_vars.bottomnav === "true") {
            this._bottomNavOffset = this.props.screen.r16_9.p10;
        }
        this.timelineRefs = [];
        // this.exiting = false;
    }

    componentWillMount() {
        shared.checkData(this.props.module);
    }

    componentWillUnmount() {
        for (let a = 0; a < this.timelineRefs.length; a++) {
            if (this.timelineRefs[a].el) {
                this.timelineRefs[a].el.removeEventListener("tap", () => this.handleEventSelection(this.timelineRefs[a].data));
            }
        }
    }

    componentDidMount() {
        let totalHeight = (this.state.module.contents.events.length + 1) * (this.props.screen.sv.height / config.events_on_screen); // + this.props.screen.sv.height * 2;
        this.getRelativeLocations(this.state.module.contents.events, totalHeight, 0)
    }

    componentDidUpdate() {

    }

    // shouldComponentUpdate(){
    //     return false;
    // }

    initializeTimelineRefs = () => {
        if (this.state.initializedRefs === false) {
            for (let a = 0; a < this.timelineRefs.length; a++) {
                this.timelineRefs[a].el.addEventListener("tap", () => this.handleEventSelection(this.timelineRefs[a].data));
            }
            this.setState({
                initializedRefs: true
            })
        }
    }

    closeStory = () => {
        this.props.toggleShowClock(true);
        this.setState({
            showStory: false,
            story: {
                id: -1
            }
        })
    }

    getRelativeLocations(events, totalHeight, topMargin) {

        spacialEvents = [];

      //  if (this.state.module.contents.event_spacing === "even") {
            let eventInc = this.props.screen.sv.height / config.events_on_screen;
            events = _.orderBy(events, 'rank', 'desc');
            _.forEach(events, (event, index) => {
                let raw = eventInc * index;
                let span = raw + eventInc;
                spacialEvents.push({ header: event.header, date: this.parseDate(new Date(event.date * 1000)), offset: span, raw: raw, text: event.text, images: event.images, story: event.story })
            });
            this.setState({
                spacialEvents: spacialEvents,
                // sideMargin: topMargin,
                totalHeight: totalHeight
            })
            // Relative spacing not yet supported
    //    }
       // else { //relative spacing 
            // console.log("relative spacing, what the")
            // let fullTimeSpan = events[events.length - 1].date - events[0].date;
            // _.forEach(events, (event) => {
            //     let raw = (((event.date - events[0].date) / fullTimeSpan) * totalHeight)
            //     let span = raw + topMargin;
            //     spacialEvents.push({ header: event.header, date: this.parseDate(new Date(event.date * 1000)), offset: span, raw: raw, text: event.text, images: event.images, story: event.story })
            // });
            // this.setState({
            //     spacialEvents: spacialEvents,
            //     //     sideMargin: topMargin,
            //     totalHeight: totalHeight
            // })
      //  }
    }

    parseDate = (date) => {

        let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        let monthName = monthNames[date.getMonth()]
        let monthNumber = String(date.getMonth() + 1);
        let fullYear = String(date.getFullYear());
        let shortYear = fullYear.substring(2);
        let day = String(date.getDate());
        switch (this.state.module.contents.date_format) {
            case "yyyy":
                return fullYear;
            case "mmm-yyyy":
                return monthName + "-" + fullYear;
            case "mm-dd-yyyy":
                return monthNumber + "-" + day + "-" + fullYear;
            case "yy":
                return shortYear
            case "mmm-yy":
                return monthName + "-" + shortYear;
            case "mm-dd-yy":
            default:
                return monthNumber + "-" + day + "-" + shortYear;
        }
    }

    onScrollEnd = (e) => {
        this.props.resume();
        // let yVal = Math.abs(e.y);
        // let tempCurrentEvent = 0;
        // let closestDist = null; //always pinning first to zero

        // for (var i = 0; i < spacialEvents.length; i++) {
        //     let dist = Math.abs(spacialEvents[i].raw - yVal);
        //     if (closestDist === null) {
        //         tempCurrentEvent = i;
        //         closestDist = dist;
        //     }
        //     else {
        //         if (dist < closestDist) {
        //             tempCurrentEvent = i;
        //             closestDist = dist;
        //         }
        //     }
        // }

        // this.refDict[0].withIScroll(function (iScroll) {
        //     iScroll.scrollTo(-(spacialEvents[tempCurrentEvent].raw), 0, 1000);
        // })
        // this.setState({
        //     currentEvent: tempCurrentEvent
        // })
    }

    cycleDate = (mode, index) => {
        let tempCurrentEvent = this.state.currentEvent;
        if (mode === 0) { //backward
            tempCurrentEvent--;
            if (tempCurrentEvent < 0) {
                tempCurrentEvent = spacialEvents.length - 1;
            }
        }
        else if (mode === 1) { //forward
            tempCurrentEvent++;
            if (tempCurrentEvent > spacialEvents.length - 1) {
                tempCurrentEvent = 0;
            }
        }
        else { //to specific index
            tempCurrentEvent = index;
        }
        this.refDict[0].withIScroll(function (iScroll) {
            iScroll.scrollTo(-(spacialEvents[tempCurrentEvent].raw), 0, 1000);
        })
        this.setState({
            currentEvent: tempCurrentEvent
        })
    }

    renderSpacialEvents() {

        let circleRadius = this.props.screen.r16_9.p10 * 0.4

        let circle = {
            width: circleRadius,
            height: circleRadius,
            WebkitBorderRadius: circleRadius / 2,
            MozBorderRadius: circleRadius / 2,
            borderRadius: circleRadius / 2,
            backgroundColor: '#a4bcc2',
            position: 'absolute',
            left: this.props.screen.r16_9.p10 * 3 - circleRadius / 2 + this._baseInset
        }

        if (this.state.spacialEvents.length === 0) {
            return (
                <span />
            )
        }


        return (
            this.state.spacialEvents.map(function (row, i) {
                let inset = this.props.screen.r16_9.p10 * 3
                let unitSize = this.props.screen.r16_9.p10 * 0.9

                let iref = null;
                if (_.has(row, 'images[0]')) {
                    iref = row.images[0];
                    //console.log("in timeline is: ", row.images[0]);
                }
                //inset every other
                if (i % 2 === 0) {
                    inset = this.props.screen.r16_9.p10 * 5
                }
                return (
                    <div key={i} style={{ position: 'absolute', top: row.offset, zIndex: 0 }}>


                        <div style={{ position: 'absolute', backgroundColor: 'white', top: circleRadius / 2, left: this.props.screen.r16_9.p10 * 3 + this._baseInset, width: inset, height: this.props.screen.r16_9.p10 * config.line_thickness }}></div>
                        <span style={{ ...circle }} />
                        <span style={{ textAlign: 'right', width: this.props.screen.r16_9.p10 * 2, fontSize: this.props.screen.r16_9.p10 * .35, position: 'absolute', left: this.props.screen.r16_9.p10 * .5 + this._baseInset }}>
                            {row.date}
                        </span>
                        {/* onClick={() => this.handleEventSelection(row.story)} */}
                        <span ref={el => this.timelineRefs[i] = { el: el, data: row.story }} style={{ position: 'absolute', left: this.props.screen.r16_9.p10 * 2.5 + inset + this._baseInset, top: -this.props.screen.r16_9.p10 * .7 }}>
                            <InfoBlock unit={unitSize} header={row.header} text={row.text} headerColor={'#223954'} />
                            <CircleImageInfoBlock mode={this.props.screen.mode} webkey={this.props.screen.webkey} image={iref} size={unitSize * 2} screen={this.props.screen} name={row.header} />
                        </span>

                    </div>
                )

            }, this)
        )
    }

    handleEventSelection = (story_id) => {
        //console.log("event selecting");
        if (story_id) {
            this._eventIndex = _.findIndex(this.state.module.contents.events, { story: String(story_id) });

            if (this._eventIndex !== undefined) {
                let story = _.find(this.props.content.stories, { id: Number(story_id) })
                if (story) {

                    let slickAssets = [];
                    for (var i=0; i<story.contents.images.length; i++){
                        if (story.contents.images[i]){
                            let fileType = getFileType(story.contents.images[i].file_name);
                            let vType = null;
                            if (fileType === "Video"){
                                vType = videoType(story.contents.images[i].file_name);
                            }
                            slickAssets.push({fileType: fileType, videoType: vType, path: shared.dpath(this.props.screen.mode, story.contents.images[i].path, story.contents.images[i].file_name, this.props.screen.webkey)})
                        }
                    }

                    let mainimage = 'img/ui/image_default.png';//"url(img/ui/image_default.png"
                    if (story.contents.images[0]) {
                        mainimage = shared.dpath(this.props.screen.mode, story.contents.images[0].path, story.contents.images[0].file_name, this.props.screen.webkey);
                    }
                    else if (story.contents.images[1]) {
                        mainimage = shared.dpath(this.props.screen.mode, story.contents.images[1].path, story.contents.images[1].file_name, this.props.screen.webkey);
                    }
                    else if (_.has(this.state.module.contents.events[this._eventIndex], 'images[0]')){
                        var timelineFallback = this.state.module.contents.events[this._eventIndex].images[0]
                        mainimage = shared.dpath(this.props.screen.mode, timelineFallback.path, timelineFallback.file_name, this.props.screen.webkey)
                    }
                    let showQuotes = false;
                    if (_.has(story, 'contents.custom_fields.show_quotes.val')){
                        showQuotes = story.contents.custom_fields.show_quotes.val
                    }
                    this.props.toggleShowClock(false);
                    this.setState({
                        showStory: true,
                        story: {
                            contextualheader: this.props.module.name,
                            headline: story.name,
                            subtitle: story.contents.headline,
                            body: story.contents.story,
                            quote: story.contents.text1,
                            mainimage: mainimage,
                            id: story.id,
                            showQuotes: showQuotes,
                            slickAssets: slickAssets
                        }
                    })
                }
            }
        }
    }

    cycleStory = (direction) => {
        if (direction === "forward") {
            this._eventIndex += 1;
            if (this._eventIndex >= this.state.module.contents.events.length) {
                this._eventIndex = 0;
            }
        }
        else {
            this._eventIndex -= 1;
            if (this._eventIndex < 0) {
                this._eventIndex = this.state.module.contents.events.length - 1;
            }
        }
        if (!this.state.module.contents.events[this._eventIndex].story || isNaN(Number(this.state.module.contents.events[this._eventIndex].story))) {
            this.cycleStory(direction);
        }
        else {
            this.handleEventSelection(this.state.module.contents.events[this._eventIndex].story);
        }
    }

    navarea = (width, height) => {
        return (
            <div style={{ position: 'absolute', width: width, height: height - (width / 2), bottom: 0, left: 0, backgroundColor: '#424958', zIndex: 99 }} />
        )
    }

    render() {
        if (!this.state.spacialEvents) {
            return <div />
        }

        let modalBorderV = .035 * this.props.screen.screenHeight;
        let modalBorderH = .02 * this.props.screen.r16_9.width;

        let spacialEvents = this.renderSpacialEvents();
        let navarea = this.navarea(this.props.screen.r16_9.width - (modalBorderH * 2), this.props.screen.screenHeight - (modalBorderV * 2));

        return (
            <div>
                <div style={{ position: 'absolute', pointerEvents: 'none', top: 0, left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height, backgroundColor: '#496778', opacity: 1 }} />

                {/* used to make top static with top: this._titleHorizontalRule.top + this._titleHorizontalRule.height on iscroll container
                    also from iscroll container - (this._titleHorizontalRule.top + this._titleHorizontalRule.height + this._bottomNavOffset)
                    
                    <div style={{position: 'absolute', width: this.props.screen.r16_9.width, height: this._titleHorizontalRule.top + this._titleHorizontalRule.height, left: this.props.screen.r16_9.left}}>
                   
                    <span style={this._titleStyle}>{this.props.module.contents.header ? this.props.module.contents.header : <span>Timeline</span>}</span>
                    <span style={this._titleHorizontalRule} />

                    </div> */}



                <CSSTransitionGroup
                    component='div'
                    transitionName='example'
                    transitionEnterTimeout={0}
                    transitionLeaveTimeout={0}>
                    <div key={this.state.showStory}>
                        {this.state.showStory ?
                            <div>
                                <div style={{ position: 'fixed', pointerEvents: 'none', top: 0, left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height, backgroundColor: 'black', opacity: .5 }} />
                                <div style={{ pointerEvents: 'none', position: 'absolute', left: modalBorderH + this.props.screen.r16_9.left, width: this.props.screen.r16_9.width - (modalBorderH * 2), height: this.props.screen.screenHeight - (modalBorderV * 2), top: modalBorderV, backgroundColor: 'white', zIndex: 100 }}>
                                    {navarea}
                                </div>
                            </div>
                            :
                            <span />
                        }
                    </div>
                </CSSTransitionGroup>

                <div style={{ position: 'absolute', top: 0, left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height, touchAction:"none" }}>
                    <ReactIScroll ref={el => this.refDict[0] = el} iScroll={iScroll}
                        onScrollEnd={this.onScrollEnd}
                        options={{
                            mouseWheel: true,
                            scrollbars: false,
                            scrollX: false,
                            scrollY: true,
                            probeType: 2,
                            bounce: false,
                            momentum: true,
                            deceleration: 0.015,
                            useTransition: true,
                            disableTouch: false,
                            disablePointer: false,
                            disableMouse: false,
                            tap: true
                        }}
                        onRefresh={this.initializeTimelineRefs}
                    >
                        <div style={{ width: this.props.screen.r16_9.width * .6, height: this.state.totalHeight, minHeight: '100%' }}>
                            <div style={{ position: 'absolute', top: this._titleHorizontalRule.top + this._titleHorizontalRule.height, backgroundColor: 'white', left: this.props.screen.r16_9.p10 * 3 + this._baseInset, width: this.props.screen.sv.p10 * config.line_thickness, height: '100%' }} />
                            <div style={{ position: 'absolute', width: this.props.screen.r16_9.width, height: this._titleHorizontalRule.top + this._titleHorizontalRule.height }}>

                                <span style={this._titleStyle}>
                                    {this.state.module.contents.header ?
                                        this.state.module.contents.header
                                        :
                                        <span>Timeline</span>}
                                </span>
                                <span style={this._titleHorizontalRule} />

                            </div>

                            {spacialEvents}
                        </div>
                    </ReactIScroll>
                </div>


                <div style={{ zIndex: 100, position: 'fixed', pointerEvents: 'none', top: 0, left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height }}>
                    {/* Screen 2 Slides */}
                    <CSSTransitionGroup
                        component='div'
                        transitionName='example'
                        transitionEnterTimeout={0}
                        transitionLeaveTimeout={0}>
                        <div key={this.state.story.id}>
                            {this.state.showStory ?
                                <div>
                                    {/* <div style={{ position: 'fixed', pointerEvents: 'auto', top: 0, left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height, backgroundColor: 'black', opacity: .5 }} /> */}
                                    <StoryChicagoModal
                                        backgroundEnabled={true}
                                        closeStory={this.closeStory}
                                        contextualheader={this.state.story.contextualheader} //use parent category name
                                        headline={this.state.story.headline} //use name of story
                                        subtitle={this.state.story.subtitle} //use subtitle
                                        body={this.state.story.body}
                                        quote={this.state.story.quote}
                                        mainimage={this.state.story.mainimage}
                                        left={modalBorderH}
                                        top={modalBorderV} width={this.props.screen.r16_9.width - (modalBorderH * 2)}
                                        height={this.props.screen.screenHeight - (modalBorderV * 2)}
                                        zIndex={100}
                                        cycleStory={this.cycleStory}
                                        slickAssets={this.state.story.slickAssets}//temporary TODO: see donorlist pass through
                                        showQuotes={this.state.story.showQuotes}
                                    />
                                </div>
                                :
                                <span />}
                        </div>
                    </CSSTransitionGroup>
                </div>

            </div>


        )
    }
}

const mapStateToProps = (state, ownProps) => {

    let dm;
    if (state.options && (state.options.idleModule || state.options.idleModule === 0)) {
        dm = state.content.display_module_loops[0].display_module_loop_units[state.options.idleModule].data
    }
    else if (state.content) {
        dm = state.content.dm_active[state.active_module]
    }

    return {
        content: state.content,
        screen: state.screen,
        module: dm
    }
}

export default connect(mapStateToProps, null)(Timeline)


// WEBPACK FOOTER //
// ./src/Components/Theme/Chicago/TimelineChicago.js